import { House } from "lucide-react";
import { cn } from "@/lib/utils";

export const BrandMark = ({ className }) => (
  <span
    className={cn(
      "relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-emerald-500 text-white shadow-lg shadow-emerald-500/25 ring-1 ring-white/20",
      className,
    )}
    aria-hidden="true"
  >
    <House className="h-5 w-5" strokeWidth={2.4} />
    <span className="absolute -bottom-1 -right-1 h-3 w-3 rounded-full border-2 border-slate-900 bg-sky-400" />
  </span>
);
